<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <AdminSidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

        <!-- Table Card -->
        <v-card class="table-card mt-6">

          <div class="table-header d-flex justify-space-between align-center flex-wrap ga-3">
            <div class="d-flex align-center flex-wrap ga-3">
              <!-- Left side: search + clear -->
              <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 8px;">
                <InputText v-model="filters['global'].value" placeholder="Search Interest Type..." />
                <Button type="button" icon="pi pi-filter-slash" label="Clear" variant="outlined"
                  @click="clearFilters" />
              </div>
            </div>

            <!-- <v-btn variant="flat" prepend-icon="mdi-plus" class="theme-button" @click="feeConfigDialog = true">
              New Fee Config
            </v-btn> -->
            <button type="button" :disabled="loading" class="theme-button px-5"
              @click="resetForm(); isEditing = false; editingId = null; roleDialog = true">
              <span v-if="!loading"><v-icon start>mdi-content-save-cog-outline</v-icon> Save Role </span>
            </button>
          </div>
          <!-- PrimeVue DataTable with search ---NB: add showGridlines to show column lines-->
          <DataTable v-model:filters="filters" :value="allRoles" paginator :rows="10" dataKey="uuid" stripedRows
            class="modern-table" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem"
            filterDisplay="menu" selectionMode="single" :globalFilterFields="['name', 'permissions']">

            <!-- Empty table -->
            <template #empty>
              No Role found.
            </template>

            <!-- Loading state -->
            <template #loading>
              Loading roles...
            </template>

            <!-- Name Column -->
            <Column header="Name">
              <template #body="slotProps">
                {{ capitalize(slotProps.data.name) }}
              </template>
            </Column>

            <!-- Permission Column -->
             <Column header="Permissions">
              <template #body="slotProps">

                <span v-if="slotProps.data.name === 'Superadmin'">
                  All Permissions Granted
                </span>

                <span v-else>
                  <template v-if="slotProps.data.permissions && slotProps.data.permissions.length">

                    <Badge v-for="perm in slotProps.data.permissions" :key="perm" class="mr-1 mb-1">
                      {{ capitalize(perm) }}
                    </Badge>

                  </template>

                  <span v-else class="text-gray-400">
                    No Permissions
                  </span>
                </span>

              </template>
            </Column>
            <!-- <Column header="Permissions">
              <template #body="slotProps">
                <span v-if="slotProps.data.name === 'Superadmin'">
                  All Permissions Granted
                </span>

                <span v-else>
                  <Badge>
                    {{ capitalize(slotProps.data.permissions.join(", ")) }}
                  </Badge>
                </span>
              </template>
            </Column> -->

            <!-- Status Column -->
            <!-- <Column header="Status">
              <template #body="slotProps">
                <span :class="[
                  'status-pill',
                  slotProps.data.status === true
                    ? 'status-active'
                    : 'status-inactive'
                ]">
                  {{ slotProps.data.status === true ? 'Active' : 'Inactive' }}
                </span>
              </template>
            </Column> -->


            <!-- Status Column -->
            <Column header="Added On">
              <template #body="slotProps">
                {{ formatDateTime(slotProps.data.created_at) }}
              </template>
            </Column>

            <!-- Actions Column -->
            <Column header="" style="width:120px; border-radius: 10px;">
              <template #body="slotProps">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn icon v-bind="props" variant="text">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openEditModal(slotProps.data)">
                      Edit {{ capitalize(slotProps.data.name) }} Details
                    </v-list-item>
                  </v-list>

                </v-menu>
              </template>
            </Column>

          </DataTable>
        </v-card>

        <!-- New Config Modal -->
        <v-dialog v-model="roleDialog" max-width="650">
          <v-card class="pa-6">

            <v-card-title class="text-h6 mb-4 text-center">
              {{ isEditing ? 'Edit Role' : 'Create Role' }}
            </v-card-title>

            <form @submit.prevent="handleCreateRole" class="space-y-5">

              <!-- KEY -->
              <!-- <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">Name</label>
                <v-select v-model="form.key" :items="keyItems" item-title="label" item-value="value"
                  variant="outlined" :rules="[v => !!v || 'Key is required']" />
              </div> -->

              <!-- Role Name -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">Name</label>
                <v-text-field v-model="form.name" type="text" variant="outlined" placeholder="Role Name" />
              </div>

              <!-- PERMISSION -->
             
              <div class="flex flex-col gap-2">
                <v-select v-model="form.permissions" :items="permissions" item-title="name" item-value="name"
                  label="Permissions" multiple chips variant="outlined"
                  :rules="[v => !!v || 'Permission is important']" :disabled="form.name === 'Superadmin'" />
              </div>

             

              <!-- STATUS -->
              <!-- <div class="flex items-center gap-3">
                <label class="text-sm">Role Status</label>
                <v-switch v-model="form.status" color="green" :label="form.status ? 'Active' : 'Inactive'"/>
              </div> -->

              <!-- ACTIONS -->
              <div class="flex justify-center align-center  gap-3 pt-4"
                style="display:flex; justify-content:center; align-items:center; gap:12px; padding-top:16px;">
                <v-btn variant="text" @click="roleDialog = false">
                  Cancel
                </v-btn>
                <v-btn color="black" type="submit" :loading="roleLoading" :disabled="!isFormValid">
                  {{ isEditing ? 'Update Role' : 'Save Role' }}
                </v-btn>
              </div>

            </form>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
          snackbar.message }}
          <template #actions>
            <v-btn variant="outlined" @click="snackbar.show = false">
              Cancel
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, capitalize, watch } from "vue"
import AdminSidebar from "@/components/AdminSidebar.vue"
import Header from "@/components/Header.vue"
import { adminStore } from "@/store/admin"
import { formatDateTime, getAllErrors } from "@/util"
import { executeCreateRole, executeUpdateRole } from "@/api/admin"

const roles = adminStore()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const filters = ref({ global: { value: null, matchMode: "contains" } })
const roleDialog = ref(false)
const roleLoading = ref(false)

const isEditing = ref(false)
const editingId = ref(null)

/* Mobile */
const toggleSidebar = () => {
  if (isMobile.value) drawerOpen.value = !drawerOpen.value
  else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

/* config */
const allRoles = computed(() => roles.roles || [])
const permissions = computed(() => roles.permissions || [])

/* Lifecycle */
onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  
  try {
    await roles.loadRoles()
    await roles.loadPermissions()
  } catch (error) {
    console.error(error)
  }
})

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

/* Clear filters */
const clearFilters = () => {
  filters.value = { global: { value: null, matchMode: "contains" } }
}

const snackbar = ref({
  show: false,
  message: "",
  color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
  snackbar.value.message = message
  snackbar.value.color = color
  snackbar.value.show = true
}

const form = ref({
  //id: null,
  name: '',
  permissions: [],
  status: true
})

/**
 * FORM VALIDATION STATE
 */
const isFormValid = computed(() => {
  return (
    //form.value.id &&
    form.value.name &&
    form.value.permissions &&
    form.value.status !== undefined
  )
})

/**
 * RESET FORM
 */
const resetForm = () => {
  form.value = {
    //id: null,
    name: "",
    permissions: [],
    status: true
  }
}

watch(() => form.value.name, (newVal) => {
  if (newVal === 'Superadmin') {
    form.value.permissions = permissions.value.map(p => p.name)
  } 
})

//editing modal
const openEditModal = (item) => {
  isEditing.value = true
  editingId.value = item.id

  //form.value.id = item.id || null
  form.value.name = item.name || ""
  form.value.permissions = item.permissions || []
  form.value.status = !!item.status

  roleDialog.value = true
}

//Function to create or edit
const handleCreateRole = async () => {
  roleLoading.value = true

  try {

    const payload = new FormData()

    payload.append("role", form.value.name)
    form.value.permissions.forEach((item, index) => {
      payload.append(`permissions[${index}]`, item)
    })
    payload.append("status", form.value.status)

    if (isEditing.value) {
      // update api
      await executeUpdateRole(editingId.value, payload)
    } else {
      // create api
      await executeCreateRole(payload)
    }

    // reload updated data
    await roles.loadRoles()

    //close the modal
    //roleDialog.value = false
    showSnackbar("Role created successfully")

    //resetForm()
    //roleDialog.value = false

  } catch (e) {


    const msg = getAllErrors(e)
    showSnackbar(
      msg || "Failed to save role",
      "error"
    )
  } finally {
    roleLoading.value = false
  }
}
</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background: #f8fafc;
}

/* Card */
.table-card {
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Table */
.modern-table {
  border: none;
}

/* Product */
.product-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.product-name {
  font-weight: 700;
}

.product-desc {
  font-size: 16px;
  color: #64748b;
}

/* Status */
.status-pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background: #ecfdf5;
  color: #16a34a;
}

.status-inactive {
  background: #fef2f2;
  color: #dc2626;
}

/* Search input */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 8px;
  color: #64748b;
}

.search-wrapper input {
  padding-left: 28px;
}

/* Button */
.theme-button {
  height: 46px;
  background: #000;
  color: #fff;
  border-radius: 5px;
  font-weight: 600;
  transition: all 0.25s ease;
  margin: 0px;
}

.theme-button:hover {
  background: #292828;
}

.theme-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

.p-datatable-tbody>tr {
  cursor: pointer;
}

.p-datatable-tbody>tr:hover {
  background-color: #f5f5f5;
}
</style>
